import { useState } from 'react'
import { ToggleButton, Tooltip, styled } from '@mui/material'
import { FormattedMessage } from 'react-intl'
import { BufferType } from '../types'
import NonCombinated from 'assets/icons/icon-editor-intact-boundary.svg?react'
import Combinated from 'assets/icons/icon-editor-dissolved-boundary.svg?react'
import { ProviderType } from 'features/connections'
import { ToggleButtonGroup } from '@carto/meridian-ds/components'

const BufferToggleButtonGroup = styled(ToggleButtonGroup)(({ theme }) => ({
  paddingLeft: theme.spacing(2),
  borderRadius: 0,
  borderLeft: `1px solid ${theme.palette.divider}`
}))

function BufferTypeButtons({ provider, onChange }: { provider: ProviderType; onChange: (event: BufferType) => void }) {
  const disableCombined = provider === ProviderType.REDSHIFT

  const [selected, setSelected] = useState<BufferType>(BufferType.NonCombined)

  return (
    <BufferToggleButtonGroup
      variant="unbounded"
      value={selected}
      onChange={(_, value) => {
        setSelected(value)
      }}
    >
      <ToggleButton value={BufferType.NonCombined} onClick={() => onChange(BufferType.NonCombined)}>
        <Tooltip title={<FormattedMessage id={`analysis.buffer.type.tooltips.nonCombined`} />}>
          <NonCombinated />
        </Tooltip>
      </ToggleButton>
      <ToggleButton
        value={BufferType.Combined}
        onClick={() => !disableCombined && onChange(BufferType.Combined)}
        disabled={disableCombined}
      >
        <Tooltip title={<FormattedMessage id={`analysis.buffer.type.tooltips.combined`} />}>
          <Combinated />
        </Tooltip>
      </ToggleButton>
    </BufferToggleButtonGroup>
  )
}

export default BufferTypeButtons
